const API_URL = process.env.REACT_APP_URL_ENDPOINT_MAIN;

const handleJSONResponse = (response) => response.json();

export const postExcelV2 = (data) => {
  return fetch(`${API_URL}/excel_v2/`, {
    method: 'POST',
    body: JSON.stringify({
      country_id: data.country_id,
      begin_datetime: data.begin_datetime,
      finish_datetime: data.finish_datetime,
      type: data.type,
      email: data.email,
      mall_id: data.mall_id,
      timezone: data.timezone
    }),
    headers: {
      'Content-Type': 'application/json',
    }
  }).then(handleJSONResponse)
};